/**
 * Map scan API status → ComplianceScanProgress step index (0–4).
 * getComplianceCheck does not return stats.progress; steps are derived from status + issue count.
 */

export function deriveComplianceScanStepIndex(status, { pathType, issuesFound } = {}) {
  const s = String(status || '')
    .trim()
    .toLowerCase()
    .replace(/-/g, '_');

  if (s === 'complete' || s === 'completed') return 4;
  if (s === 'failed' || s === 'cancelled') return 0;

  if (s === 'awaiting_documents') {
    return pathType ? 1 : 0;
  }

  if (s === 'checklisting') return 1;

  if (s === 'running') {
    const issues = typeof issuesFound === 'number' ? issuesFound : 0;
    if (issues > 0) return 3;
    if (pathType === 'compliance_check') return 2;
    if (pathType === 'conflict' || pathType === 'gap') return 2;
    return 1;
  }

  return 0;
}

export function isScanTerminalStatus(status) {
  const s = String(status || '')
    .trim()
    .toLowerCase();
  return s === 'complete' || s === 'completed' || s === 'failed' || s === 'cancelled';
}
